<template lang="pug">
  .report
    InputFile(
      label="arquivo afd txt" v-model="file" ref="inputFile" :allowedTypes="['text/plain']")
    PCheckbox(label="Filtrar registros por data" v-model="filtrarRegistrosPorData")
    .filtro-por-data(v-if="filtrarRegistrosPorData")
      PDatePicker(
        label="início período",
        name="inicio",
        v-model="inicio",
        format="DD/MM/YYYY"
      )

      PDatePicker(
        label="fim período",
        name="fim",
        v-model="fim",
        format="DD/MM/YYYY"
      )
    PButton(
      color="success"
      size="md"
      @click="generate"
      :loading="loading"
      :disabled="!valid || !file || !periodoValido"
    ) enviar

</template>

<script>
import moment from 'moment'
import InputFile from 'src/common/inputs/InputFile'

export default {
  components: {InputFile},
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      file: null,
      filtrarRegistrosPorData: false,
      inicio: moment().startOf('month').toDate(),
      fim: moment().endOf('month').toDate()
    }
  },
  computed: {
    periodoValido () {
      if (!this.filtrarRegistrosPorData) return true
      return this.inicio && this.fim
    }
  },
  methods: {
    getOptions () {
      return this.reportOptions
    },
    async generate () {
      if (!this.valid) return

      this.loading = true

      const compMan = this.$store.state.userInfo.compMan.id

      const fileName = `${compMan}-${(new Date()).toISOString()}`

      await this.$refs.inputFile.uploadToStorage('reports', fileName)

      const params = {
        forceKind: 'True',
        fileKey: fileName
      }

      if (this.filtrarRegistrosPorData) {
        params.inicio = moment(this.inicio).format()
        params.fim = moment(this.fim).format()
      }

      let result
      try {
        result = await this.$API.I01.save({forceKind: 'True'}, params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">

  .report {
     display: grid;
     grid-row-gap: 10px;
  }
  .filtro-por-data {
     display: grid;
     grid-auto-flow: column;
    column-gap: 10px;
  }
</style>
